<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Front Desk Account</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="submitForm">
            <label>Full Name <span class="required">*</span></label>
            <input type="text" v-model="frontDesk.name" placeholder="Full Name" required>
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <label>Email <span class="required">*</span></label>
            <input type="email" v-model="frontDesk.email" placeholder="Email" required>
            <div v-if="errors.email" class="error-message">{{ errors.email[0] }}</div>

            <label>Password <span class="required" v-if="!isEditing">*</span></label>
            <input type="password" v-model="frontDesk.password" placeholder="Password">
            <div v-if="errors.password" class="error-message">{{ errors.password[0] }}</div>

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEditing ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn"
                    @click="$router.push('/dashboard/frontdesks')">Cancel</button>
            </div>
        </form>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            frontDesk: { name: '', email: '', password: '', user_id: 0 },
            loading: false,
            isEditing: false,
            errorMessage: null,
            errors: {},
        };
    },
    methods: {
        async submitForm() {
            this.loading = true;
            this.errorMessage = null;
            this.errors = {};
            try {
                if (this.isEditing) {
                    await this.$api.put(`/frontdesks/${this.$route.params.id}`, this.frontDesk);
                } else {
                    await this.$api.post('/frontdesks', this.frontDesk);
                }
                this.$router.push('/dashboard/frontdesk');
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.errorMessage = 'You are not authorized to perform this action. Please log in.';
                } else if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    console.error("Error saving front desk account:", error);
                    this.errorMessage = 'An error occurred while saving the front desk account. Please try again later.';
                }
            }
            this.loading = false;
        },
        async fetchFrontDesk() {
            if (this.$route.params.id) {
                this.isEditing = true;
                this.loading = true;
                try {
                    const response = await this.$api.get(`/frontdesks/${this.$route.params.id}`);
                    if (!response.data.user) {
                        this.errorMessage = "An error occurred on server due to data inconsistency. Please contact admin.";
                    } else {
                        this.frontDesk.name = response.data.user.name;
                        this.frontDesk.email = response.data.user.email;
                    }
                    this.frontDesk.user_id = response.data.user_id;
                } catch (error) {
                    console.error("Error fetching front desk account:", error);
                }
                this.loading = false;
            }
        },
    },
    mounted() {
        this.fetchFrontDesk();
    }
};
</script>

<style scoped></style>
